import { useRef, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Divider, Input, Select, Space } from 'antd';
import { useSelector } from "react-redux";
import utils from './utils';
import { APIClient } from "../helpers/api_helper";
import { useDispatch } from 'react-redux';
import { loadCompanies } from '../slices/thunk';


const api = new APIClient();


const CompanySelect = ({ value = [], onChange, multiple = false, size = null, minWidth = 200, allowCreate = true, placeholder='Izberi podjetje', allowNoValue = false, defaultOpen = false, autoFocus = false, popupMatchSelectWidth }) => {

  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [open, setOpen] = useState(defaultOpen);
  const [name, setName] = useState('');

  const baseOpts = utils.processBackendOpts(useSelector((state) => state.Companies.list))
  const baseById = utils.processBackendOptsById(useSelector(state => state.Companies.byId))

  // Opt-in "N/A" pseudo-option = rows with NO company. FILTERS ONLY: it must never
  // appear on data-entry forms, where it would become an assignable value.
  const noValue = utils.noValueOption();
  const opts = allowNoValue ? [noValue, ...baseOpts] : baseOpts;
  // Also in the by-id map, or the chip for `companies=none` renders blank.
  const compsById = allowNoValue ? { ...baseById, [noValue.value]: noValue } : baseById;


  const createAndSelectNew = (e) => {

    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;

    const exists = opts.some(opt => opt.value === trimmed);
    if (exists){
      return;
    }

    api.post('/api/companies/', {'title': trimmed}, {successMsg: `Podjetje ${trimmed} uspešno ustvarjeno!`})
      .then(resp => {
        setName('');
        setOpen(false);
        onChange(resp?.id)
        dispatch(loadCompanies());  // so redux (app-wide) companies are updated!
      })
  };

  // When the value is set from outside, sometimes its an int[], sometimes just int
  // ALSO, value in the <Select> needs to be full object {'label': 'xoxo', value: 5} (and not just id)
  const selectedValues = Array.isArray(value)
      ? value.map(x => compsById[x])
      : compsById[value];

  return (
    <Select
      open={open}
      autoFocus={autoFocus}
      popupMatchSelectWidth={popupMatchSelectWidth}
      onDropdownVisibleChange={setOpen}
      mode={multiple ? "multiple" : undefined}
      showSearch
      style={{ minWidth: minWidth, flex: 1 }}
      optionFilterProp="label"
      value={selectedValues} // <-- this must be array of strings (values)
      onChange={onChange}
      options={opts}
      allowClear
      size={size}
      placeholder={placeholder}
      dropdownRender={allowCreate ? (menu => (
        <>
          {menu}
          <Divider style={{ margin: '8px 0' }} />
          <Space style={{ padding: '0 8px 4px' }}>
            <Input
              placeholder="Vnesi ime podjetja"
              ref={inputRef}
              value={name}
              onChange={e => setName(e.target.value)}
              onKeyDown={e => e.stopPropagation()}
            />
            <Button type="text" icon={<PlusOutlined />} onClick={createAndSelectNew}>
              Ustvari novo podjetje
            </Button>
          </Space>
        </>
      )) : undefined}
    />
  );
};

export default CompanySelect;
